import React from "react";
import { API_BASE_URL } from "../../../services/api";
import Button from "../../ui/Button";
import Icon from "../../ui/Icon";

const AdminAuthScreen: React.FC = () => {
  // SAML SSO 로그인 시작 - 백엔드로 리다이렉트
  const handleSamlLogin = () => {
    window.location.href = `${API_BASE_URL}/admin/auth/saml/login`;
  };

  return (
    <div className="h-screen-dvh bg-gray-50 flex flex-col">
      {/* 상단 헤더 */}
      <header className="bg-white px-4 py-3 flex items-center justify-center border-b border-gray-200">
        <h1 className="text-lg font-medium text-gray-800">관리자 로그인</h1>
      </header>

      {/* 메인 콘텐츠 */}
      <main className="flex-1 flex flex-col px-6 py-8 justify-center">
        <div className="max-w-sm mx-auto w-full">
          {/* 로고 및 제목 */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="shield" className="text-white" size="xl" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">
              관리자 인증
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed">
              관리자 권한이 필요한 페이지입니다.
              <br />
              SSO로 로그인해주세요.
            </p>
          </div>

          {/* 로그인 버튼 */}
          <div className="space-y-4">
            {/* SSO 로그인 버튼 */}
            <Button
              fullWidth
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 py-4 text-base font-medium flex items-center justify-center"
              onClick={handleSamlLogin}
            >
              <svg
                className="w-5 h-5 mr-2"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
                  fill="currentColor"
                />
              </svg>
              SSO로 로그인
            </Button>
          </div>

          {/* 안내 문구 */}
          <div className="mt-8 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
            <div className="flex items-start">
              <Icon
                name="alertTriangle"
                className="text-yellow-600 mr-2 mt-0.5"
                size="sm"
              />
              <div>
                <p className="text-yellow-800 text-sm font-medium mb-1">
                  관리자 전용 영역
                </p>
                <p className="text-yellow-700 text-xs">
                  이 영역은 관리자만 접근할 수 있습니다. SSO를 통해
                  로그인해주세요.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminAuthScreen;
